import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ExtendBidClosingDialogData {
  current_closing_at?: string | null;
  project_name?: string;
  boq_code?: string;
}

@Component({
  selector: 'app-extend-bid-closing-dialog',
  templateUrl: './extend-bid-closing-dialog.component.html',
  styleUrls: ['./extend-bid-closing-dialog.component.css']
})
export class ExtendBidClosingDialogComponent {
  form = new FormGroup({
    closing_date: new FormControl<string>('', [Validators.required]),
    closing_time: new FormControl<string>('', [Validators.required]),
    message: new FormControl<string>('')
  });
  minDate = '';

  constructor(
    public dialogRef: MatDialogRef<ExtendBidClosingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExtendBidClosingDialogData
  ) {
    const d = new Date();
    d.setMinutes(d.getMinutes() + 30);
    this.minDate = d.toISOString().slice(0, 10);
    if (data?.current_closing_at) {
      try {
        const closing = new Date(data.current_closing_at);
        if (!isNaN(closing.getTime())) {
          this.form.patchValue({
            closing_date: closing.toISOString().slice(0, 10),
            closing_time: closing.toTimeString().slice(0, 5)
          });
        }
      } catch {}
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    const date = this.form.value.closing_date;
    const time = this.form.value.closing_time;
    const message = (this.form.value.message || '').trim() || undefined;
    const iso = date && time ? new Date(`${date}T${time}:00`).toISOString() : '';
    this.dialogRef.close({ new_bid_closing_at: iso, message });
  }
}
